import { Box, Flex } from '@ergolabs/ui-kit';
import React, { FC } from 'react';

import { ConnectWalletButton } from '../../../common/components/ConnectWalletButton/ConnectWalletButton';
import { FormTitle } from '../../../common/components/FormTitle/FormTitle';

export const ConnectWalletState: FC = () => (
  <Box borderRadius="l" padding={4}>
    <Flex col>
      <Flex.Item marginBottom={6}>
        <FormTitle />
      </Flex.Item>
      <ConnectWalletButton
        caption="Connect wallet"
        size="extra-large"
        width="100%"
      />
    </Flex>
  </Box>
);
